// extracted by mini-css-extract-plugin
export default {"theme__corporateFounders":"PageLayout-module--theme__corporateFounders--MVa7P"};